import type { User } from '##schema/users.ts'
import { useRootData } from '#hooks/useData.tsx'

export function useUser(): User {
  const maybeUser = useOptionalUser()
  if (!maybeUser) throw new Error('No user. Give useOptionalUser a try')

  return maybeUser
}

function isUser(user: any): user is User {
  return user && typeof user === 'object' && typeof user.mode === 'string'
}

export function useOptionalUser(): User | undefined {
  const data = useRootData()
  if (!data || !isUser(data.user)) return

  return data.user
}
